// extracted by mini-css-extract-plugin
module.exports = {"container":"new-cars-promo-banner_container__DSd5Y","saveTag":"new-cars-promo-banner_saveTag__su4ns","text":"new-cars-promo-banner_text__r0RYa"};